// src/router/index.js
import { baseRouter as router } from '@r7e/shared';

router.addRoute(    
    {
        path: '/docs',
        name: 'Documentation',
        component: () => import('../views/DocumentationView.vue')
    }
)
// Router
router.addRoute(
    {
        path: '/',
        name: 'Home',
        component: () => import('../views/HomeView.vue'),
        meta: { requiresAuth: false }
    }
)
// router.addRoute(    
//     {
//         path: '/info',
//         name: 'AuthorInfo',
//         component: () => import('../views/AuthorInfo.vue'),
//         meta: { requiresAuth: true }
//     }
// )
router.addRoute(    
    {
        path: '/contents',
        name: 'AuthorContentList',
        component: () => import('../views/AuthorContentList.vue'),
        meta: { requiresAuth: false }
    }
)
router.addRoute(    
    {
        path: '/contents/:claimId',
        name: 'AuthorClaimDetails',
        component: () => import('../views/ClaimDetailsView.vue'),
        meta: { requiresAuth: false }
    }
)
router.addRoute(    
    {
        path: '/author/:authorId',
        name: 'Author',
        component: () => import('../views/AuthorView.vue'),
        meta: { requiresAuth: false }
    }
)
router.addRoute(    
    {
        path: '/author/:authorId/traffic',
        name: 'AuthorTraffic',
        component: () => import('../views/AuthorTrafficView.vue'),
        meta: { requiresAuth: false }
    }
)
router.addRoute(    
    {
        path: '/author/:authorId/content/:contentId/analytics',
        name: 'ContentAnalytics',
        component: () => import('../views/ContentAnalyticsView.vue'),
        meta: { requiresAuth: false }
    }
)
router.addRoute(    
    {
        path: '/authors/',
        name: 'Authors',
        component: () => import('../views/AuthorsList.vue'),
        meta: { requiresAuth: false }
    }
)

// router.addRoute(    
//     {
//         path: '/profile-setup',
//         name: 'ProfileSetup',
//         component: () => import('../views/AuthorProfileSetupView.vue'),
//         props: route => ({ redirectTo: route.query.redirectTo || '' }),
//         meta: { requiresAuth: true }
//     }
// )

// {
//     path: '/register',
//     name: 'Register',
//     component: () => import('../views/RegisterView.vue'),
//     meta: { requiresGuest: true }
// },

// router.addRoute(    
//     {
//         path: '/wizard-register',
//         name: 'WizardRegister',
//         component: () => import('../views/WizardRegisterView.vue'),
//         meta: { requiresGuest: true }
//     }
// )

// Phase 4 Testing Routes - Resource Claiming Views
router.addRoute(    
    {
        path: '/resource-claiming',
        name: 'PostLoginResourceClaiming',
        component: () => import('../views/PostLoginResourceClaimingView.vue'),
        meta: { requiresAuth: true }
    }
)

router.addRoute(
    {
        path: '/settings',
        name: 'Settings',
        component: () => import('../views/AuthorSettingsView.vue'),
        meta: { requiresAuth: false }
    }
)

// Standalone route removed - using only /resource-claiming for post-login resource claiming

export {router};
export default router;